(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ks-about-sim-modal-product-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ks-mobile-sheet')) {
    customElements.define(
      'ks-mobile-sheet',
      class KSMobileSheet extends HTMLElement {
        connectedCallback() {
          if (this.dataset.dragInitialized === 'true') return;

          this.dialog = this.closest('dialog');
          this.dialogComponent = this.closest('dialog-component');
          this.handle = this.querySelector('[data-ks-sheet-drag-handle]');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');

          if (!this.dialog || !this.handle) return;

          this.handlePointerDown = (event) => {
            if (!this.mobileQuery.matches || !event.isPrimary) return;

            this.dragging = true;
            this.pointerId = event.pointerId;
            this.startY = event.clientY;
            this.lastY = event.clientY;
            this.startTime = performance.now();
            this.lastTime = this.startTime;
            this.velocity = 0;

            this.dialog.style.setProperty('transition', 'none', 'important');
            this.handle.setPointerCapture?.(event.pointerId);
          };

          this.handlePointerMove = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            const now = performance.now();
            const elapsed = Math.max(now - this.lastTime, 1);
            const movement = event.clientY - this.lastY;
            const distance = Math.max(0, event.clientY - this.startY);

            this.velocity = movement / elapsed;
            this.lastY = event.clientY;
            this.lastTime = now;

            this.dialog.style.setProperty(
              'transform',
              `translateY(${distance}px)`,
              'important'
            );
          };

          this.finishDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            this.dragging = false;

            if (this.handle.hasPointerCapture?.(event.pointerId)) {
              this.handle.releasePointerCapture(event.pointerId);
            }

            const distance = Math.max(0, this.lastY - this.startY);
            const closeDistance = Math.min(150, this.dialog.offsetHeight * 0.18);
            const isQuickSwipe = distance > 28 && this.velocity > 0.65;
            const shouldClose = distance >= closeDistance || isQuickSwipe;

            if (shouldClose) {
              this.dialog.style.setProperty(
                'transition',
                'transform 180ms cubic-bezier(0.4, 0, 1, 1)',
                'important'
              );
              this.dialog.style.setProperty(
                'transform',
                `translateY(${this.dialog.offsetHeight}px)`,
                'important'
              );

              window.setTimeout(() => this.closeSheet(), 180);
              return;
            }

            this.dialog.style.setProperty(
              'transition',
              'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
              'important'
            );
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');

            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.cancelDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            this.dragging = false;
            this.dialog.style.setProperty(
              'transition',
              'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
              'important'
            );
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');
            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.handleDialogClose = () => this.clearDragStyles();

          this.handle.addEventListener('pointerdown', this.handlePointerDown);
          this.handle.addEventListener('pointermove', this.handlePointerMove);
          this.handle.addEventListener('pointerup', this.finishDrag);
          this.handle.addEventListener('pointercancel', this.cancelDrag);
          this.dialog.addEventListener('close', this.handleDialogClose);
          this.dataset.dragInitialized = 'true';
        }

        disconnectedCallback() {
          this.handle?.removeEventListener('pointerdown', this.handlePointerDown);
          this.handle?.removeEventListener('pointermove', this.handlePointerMove);
          this.handle?.removeEventListener('pointerup', this.finishDrag);
          this.handle?.removeEventListener('pointercancel', this.cancelDrag);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
        }

        closeSheet() {
          this.clearDragStyles();

          if (typeof this.dialogComponent?.closeDialog === 'function') {
            this.dialogComponent.closeDialog();
          } else {
            this.dialog.close();
          }
        }

        clearDragStyles() {
          this.dialog?.style.removeProperty('transition');
          this.dialog?.style.removeProperty('transform');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-collection-countries-modal-v2"] && !Shopify.designMode) return;
  try {
    (() => {
    const modal = document.getElementById('ksCollectionCountriesModal');
    if (!modal || modal.dataset.ksBound === 'true') return;

    const panel = modal.querySelector('[data-ks-ccm-panel]');
    const grid = modal.querySelector('[data-ks-ccm-grid]');
    const search = modal.querySelector('[data-ks-ccm-search]');
    const clearButton = modal.querySelector('[data-ks-ccm-clear]');
    const emptyState = modal.querySelector('[data-ks-ccm-empty]');
    const announcement = modal.querySelector('[data-ks-ccm-announcement]');
    const count = modal.querySelector('[data-ks-ccm-count]');
    const countLabel = modal.querySelector('[data-ks-ccm-count-label]');
    const productTitle = modal.querySelector('[data-ks-ccm-product-title]');
    const cta = modal.querySelector('[data-ks-ccm-cta]');
    const dragHandle = modal.querySelector('[data-ks-ccm-drag-handle]');
    const mobileQuery = window.matchMedia('(max-width: 749px)');

    let opener = null;
    let dragging = false;
    let pointerId = null;
    let startY = 0;
    let lastY = 0;
    let lastTime = 0;
    let velocity = 0;

    const normalize = (value) => {
      return (value || '')
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
    };

    const rows = () => Array.from(grid?.querySelectorAll('[data-ks-ccm-row]') || []);

    const updateCount = (visibleCount, announce = true) => {
      if (count) count.textContent = visibleCount;
      if (countLabel) {
        countLabel.textContent = visibleCount === 1 ? 'destination included' : 'destinations included';
      }
      if (announcement && announce) {
        announcement.textContent =
          visibleCount === 1 ? '1 covered destination found.' : `${visibleCount} covered destinations found.`;
      }
    };

    const filterCountries = (announce = true) => {
      const query = normalize(search?.value);
      let visibleCount = 0;

      rows().forEach((row) => {
        const countryName = normalize(row.dataset.countryName);
        const visible = countryName.includes(query);
        row.hidden = !visible;
        if (visible) visibleCount += 1;
      });

      if (clearButton) clearButton.hidden = query.length === 0;
      if (emptyState) emptyState.hidden = visibleCount !== 0;
      updateCount(visibleCount, announce);
    };

    const clearDragStyles = () => {
      panel?.style.removeProperty('transition');
      panel?.style.removeProperty('transform');
    };

    const closeModal = () => {
      if (modal.open) modal.close();
    };

    const openModal = (trigger) => {
      const targetId = trigger.getAttribute('data-countries-target');
      const template = targetId ? document.getElementById(targetId) : null;
      if (!template || !grid || !cta) return;

      opener = trigger;
      grid.replaceChildren(template.content.cloneNode(true));

      if (productTitle) productTitle.textContent = trigger.dataset.productTitle || '';
      cta.href = trigger.dataset.productUrl || '#';

      if (search) search.value = '';
      if (clearButton) clearButton.hidden = true;
      if (emptyState) emptyState.hidden = true;
      updateCount(rows().length, false);
      clearDragStyles();

      document.documentElement.classList.add('ks-ccm-scroll-locked');
      if (!modal.open) modal.showModal();
    };

    const handleTriggerClick = (event) => {
      const trigger = event.target.closest('[data-ks-ccm-open]');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
    };

    document.addEventListener('click', handleTriggerClick, true);

    modal.addEventListener('click', (event) => {
      if (event.target === modal || event.target.closest('[data-ks-ccm-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    modal.addEventListener('close', () => {
      document.documentElement.classList.remove('ks-ccm-scroll-locked');
      if (search) search.value = '';
      if (grid) grid.replaceChildren();
      if (emptyState) emptyState.hidden = true;
      clearDragStyles();
      opener?.focus({ preventScroll: true });
      opener = null;
    });

    search?.addEventListener('input', () => filterCountries());

    clearButton?.addEventListener('click', () => {
      if (!search) return;
      search.value = '';
      filterCountries();
      search.focus();
    });

    dragHandle?.addEventListener('pointerdown', (event) => {
      if (!mobileQuery.matches || !event.isPrimary || !panel) return;

      dragging = true;
      pointerId = event.pointerId;
      startY = event.clientY;
      lastY = event.clientY;
      lastTime = performance.now();
      velocity = 0;
      panel.style.setProperty('transition', 'none', 'important');
      dragHandle.setPointerCapture?.(event.pointerId);
    });

    dragHandle?.addEventListener('pointermove', (event) => {
      if (!dragging || event.pointerId !== pointerId || !panel) return;

      const now = performance.now();
      const elapsed = Math.max(now - lastTime, 1);
      const movement = event.clientY - lastY;
      const distance = Math.max(0, event.clientY - startY);

      velocity = movement / elapsed;
      lastY = event.clientY;
      lastTime = now;
      panel.style.setProperty('transform', `translateY(${distance}px)`, 'important');
    });

    const finishDrag = (event) => {
      if (!dragging || event.pointerId !== pointerId || !panel) return;

      dragging = false;
      if (dragHandle?.hasPointerCapture?.(event.pointerId)) {
        dragHandle.releasePointerCapture(event.pointerId);
      }

      const distance = Math.max(0, lastY - startY);
      const closeDistance = Math.min(150, panel.offsetHeight * 0.18);
      const quickSwipe = distance > 28 && velocity > 0.65;

      if (distance >= closeDistance || quickSwipe) {
        panel.style.setProperty(
          'transition',
          'transform 180ms cubic-bezier(0.4, 0, 1, 1)',
          'important'
        );
        panel.style.setProperty('transform', `translateY(${panel.offsetHeight}px)`, 'important');
        window.setTimeout(closeModal, 180);
        return;
      }

      panel.style.setProperty(
        'transition',
        'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
        'important'
      );
      panel.style.setProperty('transform', 'translateY(0)', 'important');
      window.setTimeout(clearDragStyles, 220);
    };

    dragHandle?.addEventListener('pointerup', finishDrag);
    dragHandle?.addEventListener('pointercancel', finishDrag);
    modal.dataset.ksBound = 'true';
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-countries-modal-product-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ks-mobile-sheet')) {
    customElements.define(
      'ks-mobile-sheet',
      class KSMobileSheet extends HTMLElement {
        connectedCallback() {
          if (this.dataset.dragInitialized === 'true') return;

          this.dialog = this.closest('dialog');
          this.dialogComponent = this.closest('dialog-component');
          this.handle = this.querySelector('[data-ks-sheet-drag-handle]');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');

          if (!this.dialog || !this.handle) return;

          this.handlePointerDown = (event) => {
            if (!this.mobileQuery.matches || !event.isPrimary) return;

            this.dragging = true;
            this.pointerId = event.pointerId;
            this.startY = event.clientY;
            this.lastY = event.clientY;
            this.startTime = performance.now();
            this.lastTime = this.startTime;
            this.velocity = 0;

            this.dialog.style.setProperty('transition', 'none', 'important');
            this.handle.setPointerCapture?.(event.pointerId);
          };

          this.handlePointerMove = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            const now = performance.now();
            const elapsed = Math.max(now - this.lastTime, 1);
            const movement = event.clientY - this.lastY;
            const distance = Math.max(0, event.clientY - this.startY);

            this.velocity = movement / elapsed;
            this.lastY = event.clientY;
            this.lastTime = now;

            this.dialog.style.setProperty(
              'transform',
              `translateY(${distance}px)`,
              'important'
            );
          };

          this.finishDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            this.dragging = false;

            if (this.handle.hasPointerCapture?.(event.pointerId)) {
              this.handle.releasePointerCapture(event.pointerId);
            }

            const distance = Math.max(0, this.lastY - this.startY);
            const closeDistance = Math.min(150, this.dialog.offsetHeight * 0.18);
            const isQuickSwipe = distance > 28 && this.velocity > 0.65;
            const shouldClose = distance >= closeDistance || isQuickSwipe;

            if (shouldClose) {
              this.dialog.style.setProperty(
                'transition',
                'transform 180ms cubic-bezier(0.4, 0, 1, 1)',
                'important'
              );
              this.dialog.style.setProperty(
                'transform',
                `translateY(${this.dialog.offsetHeight}px)`,
                'important'
              );

              window.setTimeout(() => this.closeSheet(), 180);
              return;
            }

            this.dialog.style.setProperty(
              'transition',
              'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
              'important'
            );
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');

            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.cancelDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            this.dragging = false;
            this.dialog.style.setProperty(
              'transition',
              'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
              'important'
            );
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');
            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.handleDialogClose = () => this.clearDragStyles();

          this.handle.addEventListener('pointerdown', this.handlePointerDown);
          this.handle.addEventListener('pointermove', this.handlePointerMove);
          this.handle.addEventListener('pointerup', this.finishDrag);
          this.handle.addEventListener('pointercancel', this.cancelDrag);
          this.dialog.addEventListener('close', this.handleDialogClose);
          this.dataset.dragInitialized = 'true';
        }

        disconnectedCallback() {
          this.handle?.removeEventListener('pointerdown', this.handlePointerDown);
          this.handle?.removeEventListener('pointermove', this.handlePointerMove);
          this.handle?.removeEventListener('pointerup', this.finishDrag);
          this.handle?.removeEventListener('pointercancel', this.cancelDrag);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
        }

        closeSheet() {
          this.clearDragStyles();

          if (typeof this.dialogComponent?.closeDialog === 'function') {
            this.dialogComponent.closeDialog();
          } else {
            this.dialog.close();
          }
        }

        clearDragStyles() {
          this.dialog?.style.removeProperty('transition');
          this.dialog?.style.removeProperty('transform');
        }
      }
    );
  }

  if (!customElements.get('ks-country-search')) {
    customElements.define(
      'ks-country-search',
      class KSCountrySearch extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.input = this.querySelector('[data-ks-country-search]');
          this.clearButton = this.querySelector('[data-ks-country-clear]');
          this.emptyState = this.querySelector('[data-ks-country-empty]');
          this.announcement = this.querySelector('[data-ks-country-announcement]');
          this.rows = Array.from(this.querySelectorAll('[data-ks-country-row]'));
          this.dialog = this.closest('dialog');
          this.count = this.dialog?.querySelector('[data-ks-country-count]');
          this.countLabel = this.dialog?.querySelector('[data-ks-country-count-label]');

          if (!this.input || !this.rows.length) return;

          this.handleInput = () => this.filterCountries();
          this.handleClear = () => {
            this.input.value = '';
            this.filterCountries();
            this.input.focus();
          };
          this.handleDialogClose = () => {
            this.input.value = '';
            this.filterCountries(false);
          };

          this.input.addEventListener('input', this.handleInput);
          this.clearButton?.addEventListener('click', this.handleClear);
          this.dialog?.addEventListener('close', this.handleDialogClose);
          this.dataset.initialized = 'true';
        }

        disconnectedCallback() {
          this.input?.removeEventListener('input', this.handleInput);
          this.clearButton?.removeEventListener('click', this.handleClear);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
        }

        normalize(value) {
          return value
            .toLocaleLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim();
        }

        filterCountries(announce = true) {
          const query = this.normalize(this.input.value);
          let visibleCount = 0;

          this.rows.forEach((row) => {
            const countryName = this.normalize(row.dataset.countryName || '');
            const isVisible = countryName.includes(query);
            row.hidden = !isVisible;
            if (isVisible) visibleCount += 1;
          });

          if (this.clearButton) this.clearButton.hidden = query.length === 0;
          if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
          if (this.count) this.count.textContent = visibleCount;
          if (this.countLabel) {
            this.countLabel.textContent =
              visibleCount === 1 ? 'destination included' : 'destinations included';
          }

          if (announce && this.announcement) {
            this.announcement.textContent =
              visibleCount === 1 ? '1 covered destination found.' : `${visibleCount} covered destinations found.`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-esim-device-modal-product-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ks-device-mobile-sheet')) {
    customElements.define(
      'ks-device-mobile-sheet',
      class KSDeviceMobileSheet extends HTMLElement {
        connectedCallback() {
          if (this.dataset.dragInitialized === 'true') return;

          this.dialog = this.closest('dialog');
          this.dialogComponent = this.closest('dialog-component');
          this.handle = this.querySelector('[data-ks-device-sheet-drag-handle]');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');

          if (!this.dialog || !this.handle) return;

          this.handlePointerDown = (event) => {
            if (!this.mobileQuery.matches || !event.isPrimary) return;

            this.dragging = true;
            this.pointerId = event.pointerId;
            this.startY = event.clientY;
            this.lastY = event.clientY;
            this.startTime = performance.now();
            this.lastTime = this.startTime;
            this.velocity = 0;

            this.dialog.style.setProperty('transition', 'none', 'important');
            this.handle.setPointerCapture?.(event.pointerId);
          };

          this.handlePointerMove = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            const now = performance.now();
            const elapsed = Math.max(now - this.lastTime, 1);
            const movement = event.clientY - this.lastY;
            const distance = Math.max(0, event.clientY - this.startY);

            this.velocity = movement / elapsed;
            this.lastY = event.clientY;
            this.lastTime = now;

            this.dialog.style.setProperty(
              'transform',
              `translateY(${distance}px)`,
              'important'
            );
          };

          this.finishDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            this.dragging = false;

            if (this.handle.hasPointerCapture?.(event.pointerId)) {
              this.handle.releasePointerCapture(event.pointerId);
            }

            const distance = Math.max(0, this.lastY - this.startY);
            const closeDistance = Math.min(150, this.dialog.offsetHeight * 0.18);
            const isQuickSwipe = distance > 28 && this.velocity > 0.65;
            const shouldClose = distance >= closeDistance || isQuickSwipe;

            if (shouldClose) {
              this.dialog.style.setProperty(
                'transition',
                'transform 180ms cubic-bezier(0.4, 0, 1, 1)',
                'important'
              );
              this.dialog.style.setProperty(
                'transform',
                `translateY(${this.dialog.offsetHeight}px)`,
                'important'
              );

              window.setTimeout(() => this.closeSheet(), 180);
              return;
            }

            this.dialog.style.setProperty(
              'transition',
              'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
              'important'
            );
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');

            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.cancelDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            this.dragging = false;
            this.dialog.style.setProperty(
              'transition',
              'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
              'important'
            );
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');
            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.handleDialogClose = () => this.clearDragStyles();

          this.handle.addEventListener('pointerdown', this.handlePointerDown);
          this.handle.addEventListener('pointermove', this.handlePointerMove);
          this.handle.addEventListener('pointerup', this.finishDrag);
          this.handle.addEventListener('pointercancel', this.cancelDrag);
          this.dialog.addEventListener('close', this.handleDialogClose);
          this.dataset.dragInitialized = 'true';
        }

        disconnectedCallback() {
          this.handle?.removeEventListener('pointerdown', this.handlePointerDown);
          this.handle?.removeEventListener('pointermove', this.handlePointerMove);
          this.handle?.removeEventListener('pointerup', this.finishDrag);
          this.handle?.removeEventListener('pointercancel', this.cancelDrag);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
        }

        closeSheet() {
          this.clearDragStyles();

          if (typeof this.dialogComponent?.closeDialog === 'function') {
            this.dialogComponent.closeDialog();
          } else {
            this.dialog.close();
          }
        }

        clearDragStyles() {
          this.dialog?.style.removeProperty('transition');
          this.dialog?.style.removeProperty('transform');
        }
      }
    );
  }

  if (!customElements.get('ks-device-search')) {
    customElements.define(
      'ks-device-search',
      class KSDeviceSearch extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.input = this.querySelector('[data-ks-device-search]');
          this.clearButton = this.querySelector('[data-ks-device-clear]');
          this.emptyState = this.querySelector('[data-ks-device-empty]');
          this.announcement = this.querySelector('[data-ks-device-announcement]');
          this.rows = Array.from(this.querySelectorAll('[data-ks-device-row]'));
          this.dialog = this.closest('dialog');
          this.count = this.dialog?.querySelector('[data-ks-device-count]');
          this.countLabel = this.dialog?.querySelector('[data-ks-device-count-label]');

          if (!this.input || !this.rows.length) return;

          this.handleInput = () => this.filterDevices();
          this.handleClear = () => {
            this.input.value = '';
            this.filterDevices();
            this.input.focus();
          };
          this.handleDialogClose = () => {
            this.input.value = '';
            this.filterDevices(false);
          };

          this.input.addEventListener('input', this.handleInput);
          this.clearButton?.addEventListener('click', this.handleClear);
          this.dialog?.addEventListener('close', this.handleDialogClose);
          this.dataset.initialized = 'true';
        }

        disconnectedCallback() {
          this.input?.removeEventListener('input', this.handleInput);
          this.clearButton?.removeEventListener('click', this.handleClear);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
        }

        normalize(value) {
          return value
            .toLocaleLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .trim();
        }

        filterDevices(announce = true) {
          const query = this.normalize(this.input.value);
          let visibleCount = 0;

          this.rows.forEach((row) => {
            const searchableDevice = this.normalize(row.dataset.deviceSearch || '');
            const isVisible = searchableDevice.includes(query);
            row.hidden = !isVisible;
            if (isVisible) visibleCount += 1;
          });

          if (this.clearButton) this.clearButton.hidden = query.length === 0;
          if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
          if (this.count) this.count.textContent = visibleCount;
          if (this.countLabel) {
            this.countLabel.textContent =
              visibleCount === 1 ? 'compatible model' : 'compatible models';
          }

          if (announce && this.announcement) {
            this.announcement.textContent =
              visibleCount === 1 ? '1 compatible device found.' : `${visibleCount} compatible devices found.`;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-product-features-modal-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ks-mobile-sheet')) {
    customElements.define(
      'ks-mobile-sheet',
      class KSMobileSheet extends HTMLElement {
        connectedCallback() {
          if (this.dataset.dragInitialized === 'true') return;

          this.dialog = this.closest('dialog');
          this.dialogComponent = this.closest('dialog-component');
          this.handle = this.querySelector('[data-ks-sheet-drag-handle]');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');

          if (!this.dialog || !this.handle) return;

          this.handlePointerDown = (event) => {
            if (!this.mobileQuery.matches || !event.isPrimary) return;

            this.dragging = true;
            this.pointerId = event.pointerId;
            this.startY = event.clientY;
            this.lastY = event.clientY;
            this.startTime = performance.now();
            this.lastTime = this.startTime;
            this.velocity = 0;

            this.dialog.style.setProperty('transition', 'none', 'important');
            this.handle.setPointerCapture?.(event.pointerId);
          };

          this.handlePointerMove = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            const now = performance.now();
            const elapsed = Math.max(now - this.lastTime, 1);
            const movement = event.clientY - this.lastY;
            const distance = Math.max(0, event.clientY - this.startY);

            this.velocity = movement / elapsed;
            this.lastY = event.clientY;
            this.lastTime = now;

            this.dialog.style.setProperty(
              'transform',
              `translateY(${distance}px)`,
              'important'
            );
          };

          this.finishDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            this.dragging = false;

            if (this.handle.hasPointerCapture?.(event.pointerId)) {
              this.handle.releasePointerCapture(event.pointerId);
            }

            const distance = Math.max(0, this.lastY - this.startY);
            const closeDistance = Math.min(150, this.dialog.offsetHeight * 0.18);
            const isQuickSwipe = distance > 28 && this.velocity > 0.65;
            const shouldClose = distance >= closeDistance || isQuickSwipe;

            if (shouldClose) {
              this.dialog.style.setProperty(
                'transition',
                'transform 180ms cubic-bezier(0.4, 0, 1, 1)',
                'important'
              );
              this.dialog.style.setProperty(
                'transform',
                `translateY(${this.dialog.offsetHeight}px)`,
                'important'
              );

              window.setTimeout(() => this.closeSheet(), 180);
              return;
            }

            this.dialog.style.setProperty(
              'transition',
              'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
              'important'
            );
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');

            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.cancelDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;

            this.dragging = false;
            this.dialog.style.setProperty(
              'transition',
              'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)',
              'important'
            );
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');
            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.handleDialogClose = () => this.clearDragStyles();

          this.handle.addEventListener('pointerdown', this.handlePointerDown);
          this.handle.addEventListener('pointermove', this.handlePointerMove);
          this.handle.addEventListener('pointerup', this.finishDrag);
          this.handle.addEventListener('pointercancel', this.cancelDrag);
          this.dialog.addEventListener('close', this.handleDialogClose);
          this.dataset.dragInitialized = 'true';
        }

        disconnectedCallback() {
          this.handle?.removeEventListener('pointerdown', this.handlePointerDown);
          this.handle?.removeEventListener('pointermove', this.handlePointerMove);
          this.handle?.removeEventListener('pointerup', this.finishDrag);
          this.handle?.removeEventListener('pointercancel', this.cancelDrag);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
        }

        closeSheet() {
          this.clearDragStyles();

          if (typeof this.dialogComponent?.closeDialog === 'function') {
            this.dialogComponent.closeDialog();
          } else {
            this.dialog.close();
          }
        }

        clearDragStyles() {
          this.dialog?.style.removeProperty('transition');
          this.dialog?.style.removeProperty('transform');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ks-shipping-handling-modal-product-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ks-mobile-sheet')) {
    customElements.define(
      'ks-mobile-sheet',
      class KSMobileSheet extends HTMLElement {
        connectedCallback() {
          if (this.dataset.dragInitialized === 'true') return;

          this.dialog = this.closest('dialog');
          this.dialogComponent = this.closest('dialog-component');
          this.handle = this.querySelector('[data-ks-sheet-drag-handle]');
          this.mobileQuery = window.matchMedia('(max-width: 749px)');
          if (!this.dialog || !this.handle) return;

          this.handlePointerDown = (event) => {
            if (!this.mobileQuery.matches || !event.isPrimary) return;
            this.dragging = true;
            this.pointerId = event.pointerId;
            this.startY = event.clientY;
            this.lastY = event.clientY;
            this.lastTime = performance.now();
            this.velocity = 0;
            this.dialog.style.setProperty('transition', 'none', 'important');
            this.handle.setPointerCapture?.(event.pointerId);
          };

          this.handlePointerMove = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;
            const now = performance.now();
            const elapsed = Math.max(now - this.lastTime, 1);
            const movement = event.clientY - this.lastY;
            const distance = Math.max(0, event.clientY - this.startY);
            this.velocity = movement / elapsed;
            this.lastY = event.clientY;
            this.lastTime = now;
            this.dialog.style.setProperty('transform', `translateY(${distance}px)`, 'important');
          };

          this.finishDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;
            this.dragging = false;
            if (this.handle.hasPointerCapture?.(event.pointerId)) {
              this.handle.releasePointerCapture(event.pointerId);
            }

            const distance = Math.max(0, this.lastY - this.startY);
            const closeDistance = Math.min(150, this.dialog.offsetHeight * 0.18);
            const shouldClose = distance >= closeDistance || (distance > 28 && this.velocity > 0.65);

            if (shouldClose) {
              this.dialog.style.setProperty('transition', 'transform 180ms cubic-bezier(0.4, 0, 1, 1)', 'important');
              this.dialog.style.setProperty('transform', `translateY(${this.dialog.offsetHeight}px)`, 'important');
              window.setTimeout(() => this.closeSheet(), 180);
              return;
            }

            this.dialog.style.setProperty('transition', 'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)', 'important');
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');
            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.cancelDrag = (event) => {
            if (!this.dragging || event.pointerId !== this.pointerId) return;
            this.dragging = false;
            this.dialog.style.setProperty('transition', 'transform 220ms cubic-bezier(0.22, 1, 0.36, 1)', 'important');
            this.dialog.style.setProperty('transform', 'translateY(0)', 'important');
            window.setTimeout(() => this.clearDragStyles(), 220);
          };

          this.handleDialogClose = () => this.clearDragStyles();
          this.handle.addEventListener('pointerdown', this.handlePointerDown);
          this.handle.addEventListener('pointermove', this.handlePointerMove);
          this.handle.addEventListener('pointerup', this.finishDrag);
          this.handle.addEventListener('pointercancel', this.cancelDrag);
          this.dialog.addEventListener('close', this.handleDialogClose);
          this.dataset.dragInitialized = 'true';
        }

        disconnectedCallback() {
          this.handle?.removeEventListener('pointerdown', this.handlePointerDown);
          this.handle?.removeEventListener('pointermove', this.handlePointerMove);
          this.handle?.removeEventListener('pointerup', this.finishDrag);
          this.handle?.removeEventListener('pointercancel', this.cancelDrag);
          this.dialog?.removeEventListener('close', this.handleDialogClose);
        }

        closeSheet() {
          this.clearDragStyles();
          if (typeof this.dialogComponent?.closeDialog === 'function') {
            this.dialogComponent.closeDialog();
          } else {
            this.dialog.close();
          }
        }

        clearDragStyles() {
          this.dialog?.style.removeProperty('transition');
          this.dialog?.style.removeProperty('transform');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
